import { render, staticRenderFns } from "./package-status.vue?vue&type=template&id=f4bda0d8"
import script from "./package-status.vue?vue&type=script&lang=js"
export * from "./package-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports